module.exports = __webpack_public_path__ + "img/01.fcfc773b.jpg";